import { ADUsers, UserProps } from "../userTypes";

export const getAdUsers = (): ADUsers[] => [
  {
    name: "Lewis Clayton",
    user_uuid: "95250181-2303-4674-a82y-343e3adb7567",
    mail: "Lewis.Clayton@modec.com",
    user_id: 1,
    position: null,
  },
  {
    name: "Joan Daniel",
    user_uuid: "95250181-230f-4674-a825-343e3adb7567",
    mail: "Joan.Daniels@modec.com",
    user_id: 2,
    position: null,
  },
  {
    name: "Michael Hayes",
    user_uuid: "95250181-234f-4674-a825-343e3adb7567",
    mail: "Michael.Hayes@modec.com",
    user_id: 3,
    position: null,
  },
  {
    name: "Michael Biggie",
    user_uuid: "95254351-234f-8908-a825-343e3adb7567",
    mail: "Michael.Biggie@modec.com",
    user_id: 4,
    position: null,
  },
  {
    name: "John Smith",
    user_uuid: "789765-234f-8908-a825-343e3adb7567",
    mail: "John.Smith@modec.com",
    user_id: 5,
    position: null,
  },
];

export const getDefaultUserInfo = (): UserProps => ({
  emails: [],
  email: "",
  scp: "",
  oid: "",
  exp: 0,
  iat: 0,
  last_login: null,
  mail: "",
  name: "",
  permissions: null,
  position: "",
  token: "",
  last_uuid: "",
  user_id: "",
  vessel_role_permission_list: [
    {
      cd_vessel: "",
      due_date: null,
      permission_list: [],
      role_id: 1,
      role_name: "",
    },
  ],
});
